import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { withI18next } from 'lib/i18n/withI18next'
import compose from 'recompose/compose'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import { ICON_SIZE } from 'components/common/icon/const'
import { connect } from 'react-redux'
import getConfiguration from 'lib/api/configuration'
import ResponsiveImage from 'components/images/responsive-image'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import { bindActionCreators } from 'redux'
import CartDuck from 'components/cart/duck'
import Loader from 'components/loader'
import cartItemsDuck from 'components/cart/cart-items/duck'
import Router from 'next/router'
import StateStorage from 'lib/state-storage'
import styles from './subscribe-diamond-section-card.scss'
import useAddDiamondToCart from '../useEffect/useAddDiamondToCart/useAddDiamondToCart'

const SubscribeDiamondSectionCard = ({
  t,
  refType,
  isPhone,
  addToCart,
  updateCart,
  applyStoreCredit,
}) => {
  const [loyaltyData, setLoyaltyData] = useState(null)
  const { handleClickAddToCart, isAddingCart } = useAddDiamondToCart({
    refType,
    addToCart,
    updateCart,
    id_product: loyaltyData?.diamond_product?.id_product,
    id_product_attribute: loyaltyData?.diamond_product?.id_product_attribute,
    applyStoreCredit,
  })
  const shop = StateStorage.getShop()
  const language = StateStorage.getLanguage()
  const backgroundImage = loyaltyData?.banner_image_full_url
  const tierColor = loyaltyData?.tier_color

  useEffect(() => {
    const fetchLoyaltyData = async () => {
      try {
        const res = await getConfiguration({
          name: 'LoyaltyDiamondExclusiveContent_20260114',
        })
        if (res) {
          setLoyaltyData(res?.configuration)
        }
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
    }

    fetchLoyaltyData()
  }, [])

  if (!loyaltyData) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    )
  }

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      <div className="subscribe-diamond-section-card">
        <ResponsiveImage
          src={backgroundImage ?? ''}
          imgRatio={isPhone ? 1.78 : 3.13}
          alt={t('diamond-section-banner')}
          className="subscribe-diamond-section-card__image"
        />
        <div className={clsx('subscribe-diamond-section-card__info')}>
          <div className={clsx(Typo.subtitle1)}>
            {hasLocizeTranslation(
              t,
              loyaltyData?.banner_title_key,
              'Exclusive Diamond savings, all year long.',
            )}
          </div>
          <div
            className={clsx('subscribe-diamond-section-card__info__benefits')}
          >
            {loyaltyData?.summary_benefits?.map(
              ({ icon_url_white, title_key }) => (
                <div
                  key={title_key}
                  className="subscribe-diamond-section-card__info__benefits__content"
                >
                  <Icon
                    className="subscribe-diamond-section-card__info__benefits__icon"
                    size={ICON_SIZE.medium}
                    src={icon_url_white}
                  />
                  <div className={Typo.caption}>
                    {hasLocizeTranslation(t, title_key, title_key)}
                  </div>
                </div>
              ),
            )}
          </div>
          <div>
            <div className={Typo.caption}>
              {hasLocizeTranslation(
                t,
                loyaltyData?.diamond_product_subscription_price_key,
                '฿84/month (฿999 billed yearly)',
              )}
            </div>
            <Button
              type={BUTTON_TYPES.textDark}
              style={{ color: tierColor }}
              className="subscribe-diamond-section-card__info__cta-button"
              onClick={handleClickAddToCart}
            >
              {isAddingCart ? (
                <Loader small />
              ) : (
                hasLocizeTranslation(t, 'BUY_&_USE_NOW', 'BUY & USE NOW')
              )}
            </Button>
            <Button
              onClick={() =>
                Router.push(`/${shop}/${language}/loyalty-diamond`, {
                  pathname: `/loyalty-diamond`,
                })
              }
              type={BUTTON_TYPES.textDark}
            >
              {hasLocizeTranslation(t, 'LEARN MORE', 'LEARN MORE')}
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

SubscribeDiamondSectionCard.defaultProps = {
  applyStoreCredit: undefined,
}

SubscribeDiamondSectionCard.propTypes = {
  // component props
  t: PropTypes.func.isRequired,
  applyStoreCredit: PropTypes.bool,
  isPhone: PropTypes.bool.isRequired,
  addToCart: PropTypes.func.isRequired,
  refType: PropTypes.string.isRequired,
  updateCart: PropTypes.func.isRequired,
}

export default compose(
  connect(
    (state) => ({
      isPhone: state.device.isPhone,
      applyStoreCredit: state.cartData.isStoreCreditUsed,
    }),
    (dispatch) =>
      bindActionCreators(
        {
          addToCart: CartDuck.creators.get,
          updateCart: cartItemsDuck.creators.update,
        },
        dispatch,
      ),
  ),
  withI18next(),
)(SubscribeDiamondSectionCard)
